import { render } from "./OptStatView.vue?vue&type=template&id=7cd6be8e"
import script from "./OptStatView.vue?vue&type=script&lang=js"
export * from "./OptStatView.vue?vue&type=script&lang=js"

import "./OptStatView.vue?vue&type=style&index=0&id=7cd6be8e&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__